import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';

import ViewDialog from './components/ViewDialog';

import Spinner from '@/components/common/Spinner';

const Document = ({ doc, onDelete }) => {
  const [submitting, setSubmitting] = useState(false);
  const [open, setIsOpen] = useState(false);

  const handleDelete = async () => {
    setSubmitting(true);
    await onDelete(doc.id);
    setSubmitting(false);
  };

  return (
    <>
      <div className="flex justify-between items-center py-1">
        <span className="truncate max-w-[200px] inline-block" title={doc.name}>
          {doc.name}
        </span>
        <div className="flex items-center gap-4">
          <Button variant="outline" size="sm" onClick={() => setIsOpen(true)}>
            View
          </Button>
          {submitting && <Spinner />}
          {!submitting && <Trash2 onClick={handleDelete} />}
        </div>
      </div>
      {open && <ViewDialog document={doc} open={open} setIsOpen={setIsOpen} />}
    </>
  );
};

export default Document;
